import { atom } from 'jotai'

/**
 * 配車板の縦横スクロールコンテナ。
 * ピン止め行は外側にあるため、横位置の同期とドロップ時刻の算出で scrollLeft を参照する。
 */
export const dispatchBoardScrollElementAtom = atom<HTMLDivElement | null>(null)

dispatchBoardScrollElementAtom.debugLabel = 'dispatchBoardScrollElementAtom'
